
const initialState = {
  initialized: false
};

const reducer = (state = initialState, { type, payload = null }) => state;

export default reducer;
